export default class FragmentPromotion {

    constructor($view) {
        this.$view = $view;
        this.$promotions = this.$view.find('.promotion-card');
        this.$promotionsBtn = this.$view.find('.click-promotion');
        this.bind();
    }

    bind() {

        this.$promotionsBtn.on('click', (e) => {
            let btnId = e.target.id;
            this.hidePromotions();
            this.showButtons();
            this.showPromotion(btnId);
            this.hideButton(btnId);
        });
    }

    hideButton(id) {
        this.$view.find('#promotion-btn-' + id + '').hide();
    }

    showPromotion(id) {
        this.$view.find('#promotion-' + id + '').show();
    }

    hidePromotions() {
        this.$promotions.hide();
    }

    showButtons() {
        this.$promotionsBtn.show();
    }
}